export type CoverageAreaRequestMessages = {
  // Success Messages
  deleteCoverageAreaSuccess: string;
  createCoverageAreaSuccess: string;
  updateCoverageAreaSuccess: string;
  loadCoverageAreasSuccess: string;

  // Error Messages
  deleteCoverageAreaError: string;
  createCoverageAreaError: string;
  updateCoverageAreaError: string;
  coverageAreaNotFoundError: string;
  coverageAreaNotFoundDescription: string;
  coverageAreaNotFoundAlt: string;
  coverageAreaErrorToLoad: string;
  loadCoverageAreasError: string;
};

export const COVERAGE_AREA_REQUEST_MESSAGES: CoverageAreaRequestMessages = {
  // Success Messages
  deleteCoverageAreaSuccess: "Área de Abrangência deletada com sucesso.",
  createCoverageAreaSuccess: "Área de Abrangência criada com sucesso.",
  updateCoverageAreaSuccess: "Área de Abrangência editada com sucesso.",
  loadCoverageAreasSuccess: "Áreas de Abrangência carregadas com sucesso.",

  // Error Messages
  deleteCoverageAreaError: "Erro ao deletar Área de Abrangência.",
  createCoverageAreaError: "Erro ao criar Área de Abrangência.",
  updateCoverageAreaError: "Erro ao editar Área de Abrangência.",
  coverageAreaNotFoundError: "Áreas de Abrangência não encontradas.",
  coverageAreaNotFoundDescription:
    "Não conseguimos encontrar nenhuma área de abrangência, recarregue a página e tente novamente.",
  coverageAreaNotFoundAlt: "Imagem indicando erro ao buscar áreas de abrangência.",
  coverageAreaErrorToLoad: "Erro ao buscar áreas de abrangência.",
  loadCoverageAreasError: "Erro ao carregar as Áreas de Abrangência. Tente novamente mais tarde.",
};
